import React, { useState } from "react"
import Navbar from "../components/Navbar"
import News from "../components/News"
import Footer from "../components/Footer"
import {
  Container,
  Wrapper,
  Title,
  Form,
  Input,
  Button,
  ButtonWrapper,
} from "../styles/RegisterStyle"
import { useDispatch, useSelector } from "react-redux"
import { login } from "../redux/apiCall"
import { renderLoginErrorMsg } from "../services/errorsForm"

const Login = () => {
  const [email, setEmail] = useState()
  const [password, setPassword] = useState()
  const dispatch = useDispatch()
  const { isFetching, error } = useSelector((state) => state.user)
  const [formErrorMsg, setFormErrorMsg] = useState()

  const handleLogin = (e) => {
    e.preventDefault()
    login(dispatch, { email, password }, setFormErrorMsg)
  }
  return (
    <Container>
      <News />
      <Navbar />
      <Wrapper>
        <Title>Login</Title>
        <Form>
          <Input
            placeholder='email'
            onChange={(e) => setEmail(e.target.value)}></Input>
          {renderLoginErrorMsg(formErrorMsg)}
          <Input
            placeholder='Password'
            onChange={(e) => setPassword(e.target.value)}
            type='password'></Input>
          {renderLoginErrorMsg(formErrorMsg)}
          <ButtonWrapper>
            <Button onClick={handleLogin} disabled={isFetching}>
              Login
            </Button>
            {/* add link to register: text: create a new account */}
          </ButtonWrapper>
        </Form>
      </Wrapper>
      <Footer />
    </Container>
  )
}
export default Login
